import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { Field } from 'formik';
import QuantitySelector from './QuantitySelector';
import { useSelector } from 'react-redux';

const SLITDetails = ({ backendErrors, isEditable }) => {
  const { en: { forms } } = useSelector((state) => state.i18n);

  return (
    <Field>
      {({ form }) => (
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <QuantitySelector
              name='slitLowDoseQuantity'
              checkBoxName='slitLowDose'
              title={forms.lowDose || 'Low Dose'}
              isEditable={isEditable}
              backendError={backendErrors.slitLowDoseQuantity}
              form={form}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <QuantitySelector
              name='slitMaintenanceQuantity'
              checkBoxName='slitMaintenance'
              title={forms.maintenance || 'Maintenance'}
              isEditable={isEditable}
              backendError={backendErrors.slitMaintenanceQuantity}
              form={form}
            />
          </Grid>
        </Grid>
      )}
    </Field>
  );
};

SLITDetails.propTypes = {
  backendErrors: PropTypes.shape({
    slitLowDoseQuantity: PropTypes.string,
    slitMaintenanceQuantity: PropTypes.string,
  }),
  isEditable: PropTypes.bool,
};

SLITDetails.defaultProps = {
  backendErrors: {},
  isEditable: true,
};

export default SLITDetails;
